// ----------------------------------------------------------------------
// <copyright file="Izenda.NLQConfigurationConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import CommonMessages from 'share/messages/Izenda.CommonMessages';
import classnames from 'classnames';
const CONFIG_STATUS_CALL_TIME = 130000;
const NLQ_NOTIFICATION_MESSAGE_KEY = {
  COMPLETED: 'COMPLETED',
  PROGRESS: 'IN_PROGRESS',
  ERROR: 'ERROR'
};
const RESET_NLQ_NOTIFICATION_MESSAGE_KEY = {
  RESETSUCCESS: 'ResetSuccess',
  RESETERROR: 'ResetError'
};
const SEARCH_MODE = {
  GUIDED: 0,
  NATURAL: 1
};

const SEARCH_MODE_TEXT = {
  GUIDED: 'Guided SearchMode Configured',
  NATURAL: 'Natural SearchMode Configured'
};

const REQUEST_MODE = {
  NONE: 0,
  CONFIG: 1,
  SWITCH: 2
};
const MESSAGE_TYPE = CommonMessages.MESSAGE_TYPE;
const NLQCONFIGURATION_STATUS_MESSAGE = CommonMessages.NLQCONFIGURATION_STATUS_MESSAGE;
const CLAZZNAME = classnames('customeHeight');
const SUCESS_CONFIG_MESSAGE = 'NLQ Module Configured';
const INFOCONFIGMESSAGE = 'NLQ configuration is in progress';
const RESET_CONFIG_MESSAGE = 'Are you sure you want to reset NLQ configuration ?';
const COMPLETED = 'COMPLETED';
const INPROGRESS = 'IN_PROGRESS';
const INITIALIZE = 'INITIALIZE';
const DELETED = 'DELETED';
const ERROR = 'ERROR';
const ERRORMESSAGE = 'We are not able to connect to ML service. Please contact administrator for this.';
const ACTIVE_NLQ_DISABLEMSG = 'Active NLQ schema is disabled';
const CONNECTION_DISABLE_MSG = 'You cannot configure this because NLQ schema is disabled';

export default {
  NLQ_NOTIFICATION_MESSAGE_KEY,
  RESET_NLQ_NOTIFICATION_MESSAGE_KEY,
  MESSAGE_TYPE,
  NLQCONFIGURATION_STATUS_MESSAGE,
  CLAZZNAME,
  SUCESS_CONFIG_MESSAGE,
  INFOCONFIGMESSAGE,
  RESET_CONFIG_MESSAGE,
  COMPLETED,
  INPROGRESS,
  INITIALIZE,
  DELETED,
  ERROR,
  ERRORMESSAGE,
  ACTIVE_NLQ_DISABLEMSG,
  CONNECTION_DISABLE_MSG,
  SEARCH_MODE,
  REQUEST_MODE,
  CONFIG_STATUS_CALL_TIME,
  SEARCH_MODE_TEXT
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.NLQConfigurationConstants.js